export const api_host = "https://alalmia.byrings.pro/api/";
export const image_host = "https://alalmia.byrings.pro";
